/* eslint-disable func-names */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useCallback, useEffect, useRef, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { useModal } from 'react-modal-hook'
import { Formik, Form, Field } from 'formik'
import Loading from 'custom/assets/loaders/Loading'
import NewCustomerService from '../../../services/new-customer.service'
import '../../../styles/NewCustomer.css'
import UploadIDProof from 'custom//assets/icons/new-customer/proof/2120848'
import Modal from '../../../components/Modal/Modal'
import UploadAddressProof from 'custom/assets/icons/new-customer/proof/1001371'
import UploadSelfie from 'custom/assets/icons/new-customer/selfie/computer'
import Congratulations from 'custom/assets/icons/new-customer/congratulations/686308'
import {
  // NewCustomerDetailsForm0Schema,
  NewCustomerDetailsForm1Schema,
  NewCustomerDetailsForm2Schema,
  NewCustomerDetailsForm3Schema,
} from '../../../schemas/auth'
import NeoInput from '../../../components/NeoInput/NeoInput'
import NeoButton from '../../../components/NeoButton/NeoButton'
import InputError from '../../../components/InputError/InputError'
import { getFormattedIdentityNumber } from '../../../utils/amount-util'
import { DIALOG_KEYS, AUTH_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import NewCustomerCard from './NewCustomerCard/NewCustomerCard'
import { Scrollbars } from 'react-custom-scrollbars'
import moment from 'moment'
import Resizer from 'react-image-file-resizer'
import SignatureCanvas from 'react-signature-canvas'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import { NeoSuccess } from '../../../components/FormComponents'

const NrcCountryCodeList = [
  {
    countryName: 'Cameroon',
    countryCode: 'CM',
    isoCode: 'CM',
    isdCode: '237',
  },
]

export default function NewCustomer() {
  const [stage, setStage] = useState(0)
  const { t } = useTranslation()
  const history = useHistory()
  const inputFile = useRef(null)
  const inputSelfie = useRef(null)
  const inputFile1 = useRef(null)
  const addressFile = useRef(null)
  const sigPad = useRef(null)

  const [idProofImg, setIdProofImg] = useState('')
  const [identityType, setIdentityType] = useState('')
  const [idProofImgLoc, setIdProofImgLoc] = useState('')
  const [addProofImg, setAddProofImg] = useState('')
  const [addProofImgLoc, setAddProofImgLoc] = useState('')
  const [profileImg, setProfileImg] = useState('')
  const [idAddressImg, setIdAddressImg] = useState('')

  const [signatureImageData, setSignatureImageData] = useState('')
  const [profileImgLoc, setProfileImgLoc] = useState('')

  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)

  const [message, setMessage] = useState('')

  const [form0Values, setForm0Values] = useState({})
  const [form1Values, setform1Values] = useState({
    identityType: 'Passport No',
    identityNumber: '',
    issueDate: '',
    expiryDate: '',
    countryOfIssuance: 'Cameroon',
  })
  const [form2Values, setform2Values] = useState({
    customerInfo: '',
    // Tpin: '',
    firstName: '',
    lastName: '',
    middleName: '',
    maritalStatus: '',
    dateOfBirth: '',
    placeOfBirth: '',
    nationality: 'Cameroon',
  })
  const [form3Values, setForm3Values] = useState({
    phoneNumber: '',
    emailId: '',
    houseNum: '',
    street: '',
    city: '',
    district: '',
    chief: '',
    village: '',
    employmentType: '',
    sourceOfIncome: '',
    occupatio: '',
    ageGroup: '',
    howKnowAboutBank: '',
    incomeRange: '',
    countryCode: 'CM',
    // isDebitCard: false,
  })

  const [terms, setTerms] = useState('')
  const [countryCodes, setCountryCodes] = useState({ countryCodeList: [] })
  const [misClasses, setMISClasses] = useState({ values: [] })
  const [occupatList, setOccupatList] = useState({})
  const [ageGroupList, setAgeGroupList] = useState({})
  const [regionList, setRegionList] = useState({})
  const [otpEnable, setOtpEnable] = useState(false)
  const [verifyDetails,setVerifyDetails] = useState({})
  const [otp, setOtp] = useState('')
  const [accepted, setAccepted] = useState(false)
  const [requestValues, setRequestValues] = useState({
    values: {
      'Relationship Type': [],
      'Customer Identity': [],
      'Source of Income': [],
      'Employment Type': [],
      'How did you know our bank/product?': [],
      'Income Range': [],
      'Account type': [],
      'Marital Status': [],
      'Account Currency': [],
      'Customer Information': [],
      'Purpose of account opening': [],
      'Additional Service required': [],
    },
    currAndRange: {},
  })

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <h6>{message}</h6>
        <div className='mt-4 col-6 mx-auto'>
          <NeoButton type='button'  mode='newDesign' text={t(DIALOG_KEYS.CLOSE)} onClick={hideModal} />
        </div>
      </Modal>
    ),
    [message],
  )

  const fetchRequestValues = useCallback(async () => {
    try {
      setLoading(true)
      const requestValResp = await NewCustomerService.getRegistrationRequiredValues()
      setRequestValues(requestValResp)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const fetchCountryCodes = useCallback(async () => {
    try {
      setLoading(true)
      const ccResp = await NewCustomerService.getCountryCodes()
      setCountryCodes(ccResp)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const fetchMISCode = useCallback(async () => {
    try {
      setLoading(true)
      const ccResp = await NewCustomerService.getMISCode()
      setMISClasses(ccResp)
      // const occ = ccResp.res.filter(e => e === 'OCCUPATIO')
      const occ = ccResp.values['OCCUPATIO']
      setOccupatList(occ)
      // const agGroup = ccResp.res.filter(e => e === 'AGE_GROUP')
      const agGroup = ccResp.values['AGE_GROUP']
      setAgeGroupList(agGroup)
      // const reg = ccResp.res.filter(e => e === 'REGION')
      const reg = ccResp.values['REGION']
      setRegionList(reg)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const fetchTerms = useCallback(async () => {
    try {
      setLoading(true)
      const termsResp = await NewCustomerService.getNewCustomerTerms()
      setTerms(termsResp.termsAndCondition[0].message)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const accountTypeFormSubmit = useCallback((data) => {
    setLoading(true)
    setForm0Values(data)
    setLoading(false)
    setStage(1)
  }, [])

  const identityInfoSubmit = useCallback(
    async (data, { setSubmitting }) => {
      try {
        // setLoading(true)
        setSubmitting(true)
        if (
          (data.identityType?.toUpperCase() === 'PASSPORT NO' || data.identityType?.toUpperCase() === 'Driving License') &&
          data.expiryDate.length > 0 &&
          data.issueDate.length > 0
        ) {
         
          // const expiryDate = data.expiryDate.split('-')
          // const issueDate = data.issueDate.split('-')
          // console.log(issueDate)
          // debugger;
          // data.issueDate = `${issueDate[2]}-${issueDate[1]}-${issueDate[0]}`
          // data.expiryDate = `${expiryDate[2]}-${expiryDate[1]}-${expiryDate[0]}`
        }

        let x = countryCodes.countryCodeList.filter(
          (value) => value.countryName === data.countryOfIssuance)
        if (x.length > 0) {
          data.countryOfIssuance = countryCodes.countryCodeList.filter(
            (value) => value.countryName === data.countryOfIssuance,
          )[0].countryCode
        }
        // if (data.identityType === 'Driving License' && data.expiryDate.length > 0) {
        //   const expiryDate = data.expiryDate.split('-')
        //   data.expiryDate = `${expiryDate[2]}-${expiryDate[1]}-${expiryDate[0]}`
        // }

        setform1Values(data)
        // setLoading1(true)
        const response = await NewCustomerService.validateID({
          identityNumber: data.identityNumber,
          accountType: "Wallet Account",
        })

        if (response.status === 200) {
          setSubmitting(false)
          setStage(2)
        }
      } catch (err) {
        setSubmitting(false)
      }
      //
    },
    [form0Values],
  )

  const customerInfoSubmit = useCallback(
    (data, { setSubmitting }) => {
      setLoading(true)
      setSubmitting(true)

      // if (data.identityType === 'Passport' && data.expiryDate.length > 0 && data.issueDate.length > 0) {
      //   const expiryDate = data.expiryDate.split('-');
      //   const issueDate = data.issueDate.split('-');
      //   data.issueDate = `${issueDate[2]}-${issueDate[1]}-${issueDate[0]}`;
      //   data.expiryDate = `${expiryDate[2]}-${expiryDate[1]}-${expiryDate[0]}`;
      // }
      data.nationality = countryCodes.countryCodeList.filter(
        (value) => value.countryName === data.nationality,
      )[0].countryCode
      setform2Values(data)
      setSubmitting(false)
      setLoading(false)
      setStage(3)
    },
    [countryCodes],
  )

  const newCustomerSubmit = useCallback((data, { setSubmitting }) => {
    setLoading(true)
    setSubmitting(true)
    setForm3Values(data)
    setSubmitting(false)
    setLoading(false)
    setStage(4)
  }, [])

  const confirmNewCustomerSubmit = useCallback(async () => {
    try {
      setLoading(true)
      const response = await NewCustomerService.generateNewCustomerOTP({
        username: 'DEFAULT',
        email: form3Values.emailId,
        mobile: form3Values.phoneNumber,
      })
      setOtpEnable(response.data.otpEnable)
      setVerifyDetails(response.data)
      setLoading(false)
      if (response.data.otpEnable) {
        setStage(10)
      } else {
        onConfirm()
      }
    } catch (err) {
      setLoading(false)
    }
  }, [form3Values])

  const onConfirm = useCallback( async () => {
    try{
      setLoading(true)
      const ccode=countryCodes.countryCodeList.filter(e=>e.countryCode===form3Values.countryCode)[0].isdCode
        const dob = form2Values.dateOfBirth.split('-')
        const resp = await NewCustomerService.createNewCustomer({
          accountType: 'Wallet Account',
          city: form3Values.city,
          commune: form3Values.chief,
          countryOfIssuance: form1Values.countryOfIssuance,
          // currencyType: form0Values.accountCurrency,
          customerIdentityType: form1Values.identityType,
          district: form3Values.district,
          dob: form2Values.dateOfBirth,
          email: form3Values.emailId,
          employmentType: form3Values.employmentType,
          expiredDate: form1Values.expiryDate,
          familyName: form2Values.lastName,
          givenName: form2Values.firstName,
          group: '',
          howKnowAboutBank: form3Values.howKnowAboutBank,
          occupatio: form3Values.occupatio,
          ageGroup: form3Values.ageGroup,
          houseNumber: form3Values.houseNum,
          identityNumber: form1Values.identityNumber,
          incomeRange: form3Values.incomeRange,
          issueDate: form1Values.issueDate,
          maritalStatus: form2Values.maritalStatus,
          middleName: form2Values.middleName,
          mobile: form3Values.phoneNumber,
          mobileCountryCode: ccode,
          nationality: form2Values.nationality,
          placeOfBirth: form2Values.placeOfBirth,
          randomKey: verifyDetails.randomKey || '',
          selfieImageData: profileImg,
          sourceOfIncome: form3Values.sourceOfIncome,
          street: form3Values.street,
          // taxId: form2Values.Tpin,
          title: form2Values.customerInfo,
          usCitizenFLag: 'N',
          village: form3Values.village,
          frontImageData: idProofImg,
          backImageData: addProofImg,
          // isDebitCard: form3Values.isDebitCard,
          signatureImageData: signatureImageData,
          proofOfResidenceImageData: idAddressImg,
          otp: otp,
        })
        setMessage(resp.code + ': ' + resp.message)
        setLoading(false)
        setStage(11)
   } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [
    verifyDetails,
    form2Values,
    form3Values,
    addProofImg,
    idProofImg,
    signatureImageData,
    profileImg,
    idAddressImg,
    form0Values,
    countryCodes,
    otp
  ])

  // useEffect(() => {
  //   const handleFileRead = (e) => {
  //     const content = e.target.result;
  //     const image = content.toString().split(',')[1];
  //     var imgCanvas = document.createElement("canvas"),
  //     imgContext = imgCanvas.getContext("2d");
  //     // imgCanvas.width = 400;
  //     // imgCanvas.height = 300;
  //     imgContext.drawImage(image, 0, 0, 400, 300);
  //     const base64Image = imgContext.toDataURL('image/png')
  //     setIdProofImg(base64Image)
  //   }
  //   const fileReader = new FileReader()
  //   fileReader.onloadend = handleFileRead
  //   idProofImgLoc === '' ? console.log('pass') : idProofImgLoc
  // }, [idProofImgLoc])

  // useEffect(() => {
  //   const handleFileRead = (e) => {
  //     const content = e.target.result
  //     setAddProofImg(content.toString().split(',')[1])
  //   }
  //   const fileReader = new FileReader()
  //   fileReader.onloadend = handleFileRead
  //   addProofImgLoc === '' ? console.log('pass') : fileReader.readAsDataURL(addProofImgLoc)
  // }, [addProofImgLoc])

  // useEffect(() => {
  //   const handleFileRead = (e) => {
  //     const content = e.target.result
  //     setProfileImg(content.toString().split(',')[1])
  //   }
  //   const fileReader = new FileReader()
  //   fileReader.onloadend = handleFileRead
  //   profileImgLoc === '' ? console.log('pass') : fileReader.readAsDataURL(profileImgLoc)
  // }, [profileImgLoc])

  const handleUploadIdProof = useCallback((e) => {
    if (e.target.files.length > 0 && e.target.files.length * 2 <= 2 * 21) {
      Resizer.imageFileResizer(
        e.target.files[0],
        300,
        300,
        'png',
        100,
        0,
        (uri) => {
          setIdProofImg(uri.toString().split(',')[1])
        },
        'base64',
      )
    }
    else {
      setMessage('File Size should be lessthan 2MB')
      showModal()
    }
  }, [])

  const handleUploadIdBackProof = useCallback(
    (e) => {
      if (e.target.files.length > 0 && e.target.files.length * 2 <= 2 * 21) {
        Resizer.imageFileResizer(
          e.target.files[0],
          300,
          300,
          'png',
          100,
          0,
          (uri) => {
            setAddProofImg(uri.toString().split(',')[1])
          },
          'base64',
        )

        // if (e.target.files[0].size <= 25600) {
        //   setAddProofImgLoc(e.target.files[0])
        // } else {
        //   e.target.value = ''
        //   setMessage('Image Size too large. Please Upload images less than 25kb')
        //   showModal()
        //   return
        // }
      }
      else {
        setMessage('File Size should be lessthan 2MB')
        showModal()
      }
    },
    [showModal],
  )

  const handleProfileImageUpload = useCallback(
    (e) => {
      if (e.target.files.length > 0 && e.target.files.length * 2 <= 2 * 21) {
        Resizer.imageFileResizer(
          e.target.files[0],
          300,
          300,
          'png',
          100,
          0,
          (uri) => {
            setProfileImg(uri.toString().split(',')[1])
          },
          'base64',
        )
      }
      else {
        setMessage('File Size should be lessthan 2MB')
        showModal()
      }
    },
    [showModal],
  )

  const handleUploadAddressProof = useCallback(
    (e) => {
      if (e.target.files.length > 0 && e.target.files.length * 2 <= 2 * 21) {
        Resizer.imageFileResizer(
          e.target.files[0],
          300,
          300,
          'png',
          100,
          0,
          (uri) => {
            setIdAddressImg(uri.toString().split(',')[1])
          },
          'base64',
        )
      }
      else {
        setMessage('File Size should be lessthan 2MB')
        showModal()
      }
    },
    [showModal],
  )

  const handleSignature = useCallback(() => {
    const signature = sigPad.current.getTrimmedCanvas().toDataURL('image/png')
    setSignatureImageData(signature.toString().split(',')[1])
  }, [])

  useEffect(() => {
    const getValues = async () => {
      await fetchTerms()
      await fetchRequestValues()
      await fetchCountryCodes()
      await fetchMISCode()
    }
    getValues()
  }, [fetchRequestValues, fetchCountryCodes, fetchMISCode, fetchTerms])

  function renderSwitch() {
    switch (stage) {
      // case 0:
      //   return renderAccountTypeForm()
      case 1:
        return renderForm0()
      case 2:
        return renderForm1()
      case 3:
        return renderForm2()
      case 4:
        return renderImageUpload()
      case 5:
        return renderProofUpload()
      case 6:
        return renderResidenceImageUpload()
      case 7:
        return renderSignatureUpload()
      case 8:
        return renderTerms()
      case 9:
        return renderConfirm()
      case 10:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 11:
        return <NeoSuccess message={message} linkPath='/auth' />
        // return renderSuccess()
      default:
        return renderForm0()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  // function renderAccountTypeForm() {
  //   return (
  //     <div>
  //       <Formik
  //         onSubmit={accountTypeFormSubmit}
  //         validationSchema={NewCustomerDetailsForm0Schema}
  //         initialTouched={{}}
  //         initialValues={{
  //           accountType: '',
  //           accountCurrency: 'ZMW',
  //         }}>
  //         {({
  //           isSubmitting,
  //           errors,
  //           touched,
  //           handleChange,
  //           setFieldValue,
  //           values,
  //           setFieldTouched,
  //           setFieldError,
  //         }) => (
  //           <Form>
  //             <div className='row justify-content-center'>
  //               <div className='form-group col-6'>
  //                 <NeoInput
  //                   mode='select'
  //                   text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.NEW_CUSTOMER_KEYS.CURRENCY)}
  //                   name='accountCurrency'
  //                   onChange={handleChange}
  //                   keyValue={null}
  //                   list={requestValues.values['Account Currency']}
  //                 />
  //                 <InputError text={errors.accountCurrency} touched={touched.accountCurrency} />
  //               </div>
  //             </div>
  //             <div className='my-1' />
  //             <div className='mt-2 row justify-content-center'>
  //               {isSubmitting ? (
  //                 renderLoading()
  //               ) : (
  //                 <div className='col-8 mx-auto'>
  //                   {requestValues.values['Account type'].map((value) => (
  //                     <NewCustomerCard
  //                       onClick={() => {
  //                         if (values.accountCurrency === '') {
  //                           setFieldTouched('accountCurrency', true)
  //                           setFieldError('accountCurrency', 'Required')
  //                           return
  //                         }
  //                         values.accountType = value
  //                         setFieldValue('accountType', value)
  //                         accountTypeFormSubmit(values)
  //                       }}
  //                       text={value}
  //                     />
  //                   ))}
  //                   <div className='my-3' />
  //                   <div className='col-4 mx-auto'>
  //                     <NeoButton
  //                       text='Back'
  //                       type='button'
  //                       mode='newDesign'
  //                       onClick={() => {
  //                         history.push('/auth')
  //                       }}
  //                     />
  //                   </div>
  //                 </div>
  //               )}
  //             </div>
  //           </Form>
  //         )}
  //       </Formik>
  //     </div>
  //   )
  // }
  // const validateIdentityNumber = useCallback(
  //   (value) => {
  //     if (identityType === 'NRC') {
  //       if (!new RegExp('^[0-9]{6}/[0-9]{2}/[0-9]$').test(value)) {
  //         return 'Please enter a Valid NRC number'
  //       }
  //     } else if (!new RegExp('^[0-9a-zA-Z]+$').test(value)) {
  //       return 'Please enter a Valid Passport number'
  //     }
  //   },
  //   [identityType],
  // )

  function renderForm0() {
    return (
      <div>
        <Formik
          onSubmit={identityInfoSubmit}
          enableReinitialize
          validationSchema={NewCustomerDetailsForm3Schema}
          initialValues={form1Values}
          initialTouched={{}}>
          {({ isSubmitting, errors, touched, handleChange, values, setValues, setFieldValue }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    mode='select'
                    text= {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.IDENTITY_TYPE)}
                    name='identityType'
                    value={values.identityType}
                    onChange={(ele) => {
                      setFieldValue('identityType', ele.target.value)
                      setFieldValue('identityNumber', '')
                      // setFieldValue('expiryDate', '')
                    }}
                    keyValue={null}
                    list={requestValues.values['Customer Identity']}
                  />
                  <InputError text={errors.identityType} touched={touched.identityType} />
                </div>
                <div className='form-group col-12'>
                  {/* <NeoInput
                  mode='maskedInput'
                  text='Identity Number'
                  maxLength={11}
                  validate={validateIdentityNumber}
                  onChange={(values) => {
                    setFieldValue('identityNumber', values.value)
                  }}
                  name='identityNumberFormatted'
                /> */}
                  {(values.identityType?.toUpperCase() === 'NRC NO' || values.identityType?.toUpperCase() === 'Driving License') && (
                    <NeoInput
                      mode='maskedInput'
                      text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.IDENTITY_NUMBER)}
                      value={values.identityNumber}
                      maxLength={11}
                      onChange={(values) => {
                        setFieldValue('identityNumber', values.value)
                      }}
                      name='identityNumber'
                    />
                  )}

                  { (values.identityType?.toUpperCase() === 'PASSPORT NO' || values.identityType?.toUpperCase() === 'NATIONAL ID') && (
                    <NeoInput
                      text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.IDENTITY_NUMBER)}
                      value={values.identityNumber}
                      name='identityNumber'
                      onChange={handleChange}
                    />
                  )}

                  <InputError text={errors.identityNumber} touched={touched.identityNumber} />
                </div>
              </div>
              <div className='row'>
                {/* {values.identityType === 'Driving License' && (
                  <div className='form-group col-6'>
                    <NeoInput
                      text='Expiry Date'
                      name='expiryDate'
                      type='date'
                      value={values.expiryDate}
                      onChange={handleChange}
                      min={moment().format(
                        `${new Date().getFullYear()}${'-'}${(
                          '0' +
                          (new Date().getMonth() + 1)
                        ).slice(-2)}${'-'}${('0' + new Date().getDate()).slice(-2)}`,
                      )}
                    />
                    <InputError text={errors.expiryDate} touched={touched.expiryDate} />
                  </div>
                )} */}
                {(values.identityType?.toUpperCase() === 'PASSPORT NO' ||
                  values.identityType?.toUpperCase() === 'Driving License') && (
                    <Fragment>
                      <div className='form-group col-6'>
                        <NeoInput
                          text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.ISSUE_DATE)}
                          name='issueDate'
                          value={values.issueDate}
                          type='date'
                          onChange={handleChange}
                          max={moment().format(
                            `${new Date().getFullYear()}${'-'}${(
                              '0' +
                              (new Date().getMonth() + 1)
                            ).slice(-2)}${'-'}${('0' + new Date().getDate()).slice(-2)}`,
                          )}
                        />
                        <InputError text={errors.issueDate} touched={touched.issueDate} />
                      </div>
                      <div className='form-group col-6'>
                        <NeoInput
                          text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.EXPIRY_DATE)}
                          name='expiryDate'
                          type='date'
                          value={values.expiryDate}
                          onChange={handleChange}
                          min={moment().format(
                            `${new Date().getFullYear()}${'-'}${(
                              '0' +
                              (new Date().getMonth() + 1)
                            ).slice(-2)}${'-'}${('0' + new Date().getDate()).slice(-2)}`,
                          )}
                        />
                        <InputError text={errors.expiryDate} touched={touched.expiryDate} />
                      </div>
                    </Fragment>
                  )}
              </div>
              <div className='row'>
                <div className='form-group col-6'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.COUNTRY_OF_ISSUE)}
                    value={values.countryOfIssuance}
                    name='countryOfIssuance'
                    onChange={handleChange}
                    keyValue='countryName'
                    list={
                      form1Values.identityType?.toUpperCase() === 'NRC NO'
                        ? NrcCountryCodeList
                        : countryCodes.countryCodeList
                    }
                  />
                  <InputError text={errors.countryOfIssuance} touched={touched.countryOfIssuance} />
                </div></div>
              <div className='mt-5 row'>
                <div className='col-4 ml-auto'>
                  <NeoButton
                    text={t(DIALOG_KEYS.BACK)}
                    type='button'
                    mode='newDesign'
                    onClick={() => {
                     history.push("/register")
                    }}
                  />
                </div>

                <div className='col-4 ml-auto'>
                  {loading1 ? (
                    renderLoading()
                  ) : (
                    <NeoButton type='submit'  mode='newDesign' text={t(DIALOG_KEYS.NEXT)} disabled={isSubmitting} />
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderForm1() {
    return (
      <div>
        <Formik
          onSubmit={customerInfoSubmit}
          enableReinitialize
          validationSchema={NewCustomerDetailsForm1Schema}
          initialValues={form2Values}
          initialTouched={{}}>
          {({ isSubmitting, errors, touched, handleChange, values, setValues, setFieldValue }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-2'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.TITLE_FIELD)}
                    name='customerInfo'
                    onChange={handleChange}
                    keyValue={null}
                    value={values.customerInfo}
                    list={requestValues.values['Customer Information']}
                  />
                  <InputError text={errors.customerInfo} touched={touched.customerInfo} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput
                    value={values.firstName}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.FIRST_NAME)}
                    onChange={handleChange}
                    name='firstName'
                  />
                  <InputError text={errors.firstName} touched={touched.firstName} />
                </div>
                <div className='form-group col-3'>
                  <NeoInput
                    value={values.middleName}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.MIDDLE_NAME)}
                    onChange={handleChange}
                    name='middleName'
                  />
                  <InputError text={errors.middleName} touched={touched.middleName} />
                </div>
                <div className='form-group col-3'>
                  <NeoInput
                    value={values.lastName}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.LAST_NAME)}
                    onChange={handleChange}
                    name='lastName'
                  />
                  <InputError text={errors.lastName} touched={touched.lastName} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-4'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.MARITAL_STATUS)}
                    name='maritalStatus'
                    value={values.maritalStatus}
                    onChange={handleChange}
                    keyValue={null}
                    list={requestValues.values['Marital Status']}
                  />
                  <InputError text={errors.maritalStatus} touched={touched.maritalStatus} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.DATE_OF_BIRTH)}
                    name='dateOfBirth'
                    type='date'
                    value={values.dateOfBirth}
                    onChange={handleChange}
                    // max={moment().format(
                    //   `${new Date().getFullYear()-18}${'-'}${
                    //   ("0" + (new Date().getMonth() + 1)).slice(-2)
                    //   }${'-'}${("0" + (new Date().getDate())).slice(-2)}`)}
                    max={(function () {
                      const today = new Date()
                      const dd = today.getDate()
                      const mm = today.getMonth() + 1
                      const yyyy = today.getFullYear() - 18
                      return `${yyyy}-${mm < 10 ? '0' + mm : mm}-${dd < 10 ? '0' + dd : dd}`
                    })()}
                  />
                  <InputError text={errors.dateOfBirth} touched={touched.dateOfBirth} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput
                    value={values.placeOfBirth}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.PLACE_OF_BIRTH)}
                    onChange={handleChange}
                    name='placeOfBirth'
                  />
                  <InputError text={errors.placeOfBirth} touched={touched.placeOfBirth} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-4'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.NATIONALITY)}
                    value={values.nationality}
                    name='nationality'
                    onChange={handleChange}
                    keyValue='countryName'
                    list={
                      form1Values.identityType?.toUpperCase() === 'NRC NO'
                        ? NrcCountryCodeList
                        : countryCodes.countryCodeList
                    }
                  />
                  <InputError text={errors.nationality} touched={touched.nationality} />
                </div>
                {/* <div className='form-group col-3'>
                  <NeoInput value={values.Tpin} name='Tpin' onChange={handleChange} text='TPIN' />
                  <InputError text={errors.Tpin} touched={touched.Tpin} />
                </div> */}
              </div>

              <div className='mt-5 row'>
                <div className='col-4 ml-auto'>
                  {isSubmitting ? (
                    renderLoading()
                  ) : (
                    <NeoButton
                      text={t(DIALOG_KEYS.BACK)}
                      type='button'
                      mode='newDesign'
                      onClick={() => {
                        setValues(form1Values)
                        setStage(1)
                      }}
                    />
                  )}
                </div>

                <div className='col-4 ml-auto'>
                  {isSubmitting ? (
                    renderLoading()
                  ) : (
                    <NeoButton type='submit'  mode='newDesign' text={t(DIALOG_KEYS.NEXT)} disabled={isSubmitting} />
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderForm2() {
    return (
      <div>
        <Formik
          enableReinitialize
          onSubmit={newCustomerSubmit}
          validationSchema={NewCustomerDetailsForm2Schema}
          initialValues={form3Values}>
          {({ isSubmitting, errors, touched, values, setValues, handleChange, setFieldValue }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-3'>
                  <label className='control-label'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.COUNTRY_CODE)}</label>
                  <Field
                    as='select'
                    className='form-control'
                    name='countryCode'
                    onChange={handleChange}>
                    <option disabled value='' />
                    {countryCodes.countryCodeList.map((codes, i) => (
                      <option key={i} value={codes.countryCode}>
                        {codes.countryCode + '-' + codes.isdCode}
                      </option>
                    ))}
                  </Field>
                  <InputError text={errors.countryCode} touched={touched.countryCode} />
                </div>
                {/* 
                <div className='form-group col-3'>
                  <NeoInput
                    mode='select'
                    text='Country Code'
                    value={values.countryOfIssuance}
                    name='countryCode'
                    onChange={handleChange}
                    // keyValue={countryCodes.countryCodesList.country_code + '-' + countryCodes.countryCodesList.country_code}
                    list={countryCodes.countryCodesList}
                    option = {countryCodes.countryCodesList.country_code + "-" + countryCodes.countryCodesList.smsCode}
                    value ={countryCodes.countryCodesList.smsCode}
                  />
                  <InputError text={errors.countryCode} touched={touched.countryCode} />
                </div> */}

                <div className='form-group col-4'>
                  <NeoInput
                    name='phoneNumber'
                    value={values.phoneNumber}
                    onChange={(e) => {
                      const re = /^[0-9\b]+$/
                      if (e.target.value === '' || re.test(e.target.value)) {
                        setFieldValue('phoneNumber', e.target.value)
                      }
                    }}
                    maxLength={countryCodes?.countryCodeList?.filter(e=>e?.countryCode===values?.countryCode)[0]?.isdCode === 237 ? '9' : '10'}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.PHONE_NUMBER)}
                  />
                  <InputError text={errors.phoneNumber} touched={touched.phoneNumber} />
                </div>
                <div className='form-group col-5'>
                  <NeoInput
                    value={values.emailId}
                    name='emailId'
                    onChange={handleChange}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.EMAIL_ID)}
                  />
                  <InputError text={errors.emailId} touched={touched.emailId} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-5'>
                  <NeoInput
                    value={values.houseNum}
                    name='houseNum'
                    onChange={handleChange}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.HOUSE_NUMBER)}
                  />
                  <InputError text={errors.houseNum} touched={touched.houseNum} />
                </div>
                <div className='form-group col-3'>
                  <NeoInput
                    value={values.street}
                    name='street'
                    onChange={handleChange}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.STREET_LOCALITY_AREA)}
                  />
                  <InputError text={errors.street} touched={touched.street} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput
                    // mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.REGION)}
                    value={values.city}
                    name='city'
                    onChange={handleChange}
                    // keyValue={null}
                    // list={regionList}
                  />
                  <InputError text={errors.city} touched={touched.city} />
                </div>

                <div className='form-group col-4'>
                  <NeoInput
                    value={values.district}
                    name='district'
                    onChange={handleChange}
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.DISTRICT)}
                  />
                  <InputError text={errors.district} touched={touched.district} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.OCCUPATION)}
                    value={values.occupatio}
                    name='occupatio'
                    onChange={handleChange}
                    keyValue={null}
                    list={occupatList}
                  />
                  <InputError text={errors.occupatio} touched={touched.occupatio} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.AGE_GROUP)}
                    value={values.ageGroup}
                    name='ageGroup'
                    onChange={handleChange}
                    keyValue={null}
                    list={ageGroupList}
                  />
                  <InputError text={errors.ageGroup} touched={touched.ageGroup} />
                </div>
              </div>
              {/* <div className='row'>
                <div className='form-group col-3'>
                  <NeoInput value={values.district} name='district' onChange={handleChange} text='District' />
                  <InputError text={errors.district} touched={touched.district} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput value={values.chief} name='chief' onChange={handleChange} text='Chief' />
                  <InputError text={errors.chief} touched={touched.chief} />
                </div>
                <div className='form-group col-5'>
                  <NeoInput value={values.village} name='village' onChange={handleChange} text='Village' />
                  <InputError text={errors.village} touched={touched.village} />
                </div>
              </div> */}
              <div className='row'>
                <div className='form-group col-5'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.EMPLOYMENT_TYPE)}
                    value={values.employmentType}
                    name='employmentType'
                    onChange={handleChange}
                    keyValue={null}
                    list={requestValues.values['Employment Type']}
                  />
                  <InputError text={errors.employmentType} touched={touched.employmentType} />
                </div>
                <div className='form-group col-3'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.SOURCE_OF_INCOME)}
                    value={values.sourceOfIncome}
                    name='sourceOfIncome'
                    onChange={handleChange}
                    keyValue={null}
                    list={requestValues.values['Source of Income']}
                  />
                  <InputError text={errors.sourceOfIncome} touched={touched.sourceOfIncome} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.INCOME_RANGE)}
                    value={values.incomeRange}
                    name='incomeRange'
                    onChange={handleChange}
                    keyValue={null}
                    list={requestValues.values['Income Range']}
                  />
                  <InputError text={errors.incomeRange} touched={touched.incomeRange} />
                </div>
                <div className='form-group col-4'>
                  <NeoInput
                    mode='select'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.HOW_KNOW_OUR_BANK)}
                    value={values.howKnowAboutBank}
                    name='howKnowAboutBank'
                    onChange={handleChange}
                    keyValue={null}
                    list={requestValues.values['How did you know our bank/product?']}
                  />
                  <InputError text={errors.howKnowAboutBank} touched={touched.howKnowAboutBank} />
                </div>
              </div>
              {/* <div className='row mt-3'>
                <div className='col-4'>
                  <div className='form-check'>
                    <input
                      name='isDebitCard'
                      value={values.isDebitCard}
                      onChange={handleChange}
                      type='checkbox'
                      className='form-check-input'
                      id='exampleCheck1'
                    />
                    <label className='control-label' for='exampleCheck1'>
                      Request for Debit Card
                    </label>
                  </div>
                </div>
              </div> */}

              <div className='mt-5 row'>
                <div className='col-4 ml-auto'>
                  <NeoButton
                    type='button'
                    text={t(DIALOG_KEYS.BACK)}
                    mode='newDesign'
                    disabled={isSubmitting}
                    onClick={() => {
                      setValues(form2Values)
                      setStage(2)
                    }}
                  />
                </div>
                <div className='col-4 ml-auto'>
                  {isSubmitting ? (
                    renderLoading()
                  ) : (
                    <NeoButton type='submit'  mode='newDesign' text={t(DIALOG_KEYS.NEXT)} disabled={isSubmitting} />
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderProofUpload() {
    return (
      <div className='d-flex flex-column text-center'>
        <h4 className='my-4'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.UPLOAD)+' '} {form1Values.identityType+' '} {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.PROOFS)}</h4>
        {/* <span className='warning-text'>Note: Image size not exceed 25kb</span> */} 
        <div className='row'>
          <div
            className='d-flex flex-column justify-content-between align-items-center w-100 rounded-2 mr-3 bg-bluegray col-4 offset-2'
            style={{ height: 350 }}>
            <div />
            <a>
              {idProofImg.length > 1 ? (
                <img
                  className='img-fluid'
                  src={`data:image/png;base64, ${idProofImg}`}
                  ref={inputFile1}
                  alt='Upload ID Proof'
                  style={{ width: 200, height: 200 }}
                  onClick={() => {
                    inputFile1.current.click()
                  }}
                />
              ) : (
                <div
                  ref={inputFile1}
                  onClick={() => {
                    inputFile1.current.click()
                  }}>
                  <UploadIDProof />
                </div>
              )}
            </a>
            <input
              type='file'
              id='file'
              accept='.png,.jpg,.gif'
              ref={inputFile1}
              style={{ display: 'none' }}
              onChange={(e) => handleUploadIdProof(e)}
            />
            <span className='font-weight-bold text-primary mb-4'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.UPLOAD_ID_PROOF_FRONT)}</span>
          </div>
          <div
            className='d-flex flex-column justify-content-between align-items-center w-100 rounded-2 ml-3 bg-bluegray col-4'
            style={{ height: 350 }}>
            <div />
            <a>
              {addProofImg.length > 0 ? (
                <img
                  className='img-fluid'
                  src={`data:image/png;base64, ${addProofImg}`}
                  ref={inputFile}
                  alt='Upload Address Proof'
                  style={{ width: 200, height: 200 }}
                  onClick={() => {
                    inputFile.current.click()
                  }}
                />
              ) : (
                <div
                  ref={inputFile}
                  onClick={() => {
                    inputFile.current.click()
                  }}>
                  <UploadAddressProof />
                </div>
              )}
            </a>
            <input
              type='file'
              id='file'
              accept='.png,.jpg,.gif'
              ref={inputFile}
              style={{ display: 'none' }}
              onChange={(e) => handleUploadIdBackProof(e)}
            />
            <span className='font-weight-bold text-primary mb-4'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.UPLOAD_ID_PROOF_BACK)}</span>
          </div>
        </div>
        <div className='mt-5 row'>
          <div className='col-4 mx-auto'>
            <NeoButton type='button'  mode='newDesign' text={t(DIALOG_KEYS.BACK)} onClick={() => setStage(4)} />
          </div>
          <div className='col-4 mx-auto'>
            <NeoButton
              type='button'
              text={t(DIALOG_KEYS.NEXT)}
              mode='newDesign'
              disabled={idProofImg === '' || addProofImg === ''}
              onClick={() => setStage(6)}
            />
          </div>
        </div>
      </div>
    )
  }

  function renderResidenceImageUpload() {
    return (
      <div className='d-flex flex-column text-center'>
        <h4 className='my-4'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.UPLOAD_RESIDENCE_ADDRESS_PROOF)}</h4>
        <div className='row'>
          <div
            className='d-flex flex-column justify-content-between align-items-center w-100 rounded-2 bg-bluegray col-8 offset-2'
            style={{ height: 350 }}>
            <div />
            <a>
              {idAddressImg.length > 1 ? (
                <img
                  className='img-fluid'
                  src={`data:image/png;base64, ${idAddressImg}`}
                  ref={addressFile}
                  alt='Upload ID Proof'
                  style={{ width: 200, height: 200 }}
                  onClick={() => {
                    addressFile.current.click()
                  }}
                />
              ) : (
                <div
                  ref={addressFile}
                  onClick={() => {
                    addressFile.current.click()
                  }}>
                  <UploadIDProof />
                </div>
              )}
            </a>
            <input
              type='file'
              id='file'
              accept='.png,.jpg,.gif'
              ref={addressFile}
              style={{ display: 'none' }}
              onChange={(e) => handleUploadAddressProof(e)}
            />
            <span className='font-weight-bold text-primary mb-4'>
            {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.UPLOAD_RESIDENCE_ADDRESS_PROOF)}
            </span>
          </div>
        </div>

        <div className='mt-5 row'>
          <div className='col-4 mx-auto'>
            <NeoButton type='button'  mode='newDesign' text={t(DIALOG_KEYS.BACK)} onClick={() => setStage(5)} />
          </div>
          <div className='col-4 mx-auto'>
            <NeoButton
              type='button'
              text={t(DIALOG_KEYS.NEXT)}
              mode='newDesign'
              disabled={idAddressImg === ''}
              onClick={() => setStage(7)}
            />
          </div>
        </div>
      </div>
    )
  }

  function renderImageUpload() {
    return (
      <div className='d-flex flex-column text-center'>
        <h4 className='my-4'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.UPLOAD_PROFILE_IMAGE)}</h4>
        {/* <span className='warning-text'>Note: Image size not exceed 25kb</span> */}
        <div className='row'>
          {profileImg === '' ? (
            <div
              className='d-flex flex-column justify-content-between align-items-center w-100 rounded-2 bg-bluegray col-8 offset-2'
              style={{ height: 350 }}>
              <div />
              <a>
                {inputSelfie.length > 0 ? (
                  <img
                    className='img-fluid'
                    src={`data:image/png;base64, ${inputSelfie}`}
                    ref={inputSelfie}
                    alt='Upload Selfie'
                    style={{ width: 200, height: 200 }}
                    onClick={() => {
                      inputSelfie.current.click()
                    }}
                  />
                ) : (
                  <div
                    ref={inputSelfie}
                    onClick={() => {
                      inputSelfie.current.click()
                    }}>
                    <UploadSelfie />
                  </div>
                )}
              </a>
              <input
                type='file'
                id='file'
                accept='.png,.jpg,.gif'
                ref={inputSelfie}
                style={{ display: 'none' }}
                onChange={(e) => handleProfileImageUpload(e)}
              />
              <span className='font-weight-bold text-primary mb-4'>
              {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.UPLOAD_SELFIE)}
              </span>
            </div>
          ) : (
            <div
              className='d-flex flex-column justify-content-between align-items-center w-100 rounded-2 bg-bluegray col-8 offset-2'
              style={{ height: 350 }}>
              <div />
              <a
              // href='#'
              >
                <img
                  className='img-fluid'
                  height={200}
                  width={100}
                  src={`data:image/png;base64, ${profileImg}`}
                  ref={inputSelfie}
                  alt='Upload Selfie'
                  style={{ width: 200 }}
                  onClick={() => {
                    inputSelfie.current.click()
                  }}
                />
              </a>
              <input
                type='file'
                id='file'
                accept='.png,.jpg,.gif'
                ref={inputSelfie}
                style={{ display: 'none' }}
                onChange={(e) => handleProfileImageUpload(e)}
              />
              <span className='font-weight-bold text-primary mb-4'>
              {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.UPLOAD_SELFIE)}
              </span>
            </div>
          )}
        </div>
        <div className='mt-5 row'>
          <div className='col-4 mx-auto'>
            <NeoButton type='button'  mode='newDesign' text={t(DIALOG_KEYS.BACK)} onClick={() => setStage(3)} />
          </div>
          <div className='col-4 mx-auto'>
            <NeoButton
              type='button'
              text={t(DIALOG_KEYS.NEXT)}
              mode='newDesign'
              disabled={profileImg === ''}
              onClick={() => setStage(5)}
            />
          </div>
        </div>
      </div>
    )
  }

  function renderSignatureUpload() {
    return (
      <div className='d-flex flex-column text-center'>
        <h4 className='my-4'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.SIGNATURE_UPLOAD)}</h4>
        {signatureImageData.length === 0 && (
          <div className='row'>
            <div className='col-9'>
              <SignatureCanvas
                clearOnResize={false}
                canvasProps={{ width: 500, height: 200, className: 'bg-white' }}
                ref={sigPad}
                onEnd={(e) => {
                  console.log(e)
                }}
              />
            </div>
            <div className='col-3'>
              <div>
                <NeoButton
                  type='button'
                  text={t(DIALOG_KEYS.CLEAR)}
                  mode='newDesign'
                  onClick={() => {
                    sigPad.current.clear()
                  }}
                />
              </div>
              <div className='mt-3'>
                <NeoButton type='button'  mode='newDesign' text={t(DIALOG_KEYS.SAVE)} onClick={handleSignature} />
              </div>
            </div>
          </div>
        )}

        {signatureImageData.length > 0 && (
          <div
            className='d-flex flex-column justify-content-between align-items-center w-100 rounded-2 bg-bluegray col-8 offset-2'
            style={{ height: 200, padding: '40px 0' }}>
            <img
              className='img-fluid'
              height={200}
              width={200}
              src={`data:image/png;base64, ${signatureImageData}`}
              alt='Upload Selfie'
              style={{ width: 200, cursor: 'pointer' }}
              onClick={() => {
                setSignatureImageData('')
              }}
            />
          </div>
        )}

        <div className='mt-5 row'>
          <div className='col-4 mx-auto'>
            <NeoButton type='button'  mode='newDesign' text={t(DIALOG_KEYS.BACK)} onClick={() => setStage(6)} />
          </div>
          <div className='col-4 mx-auto'>
            <NeoButton
              type='button'
              mode='newDesign'
              disabled={signatureImageData === ''}
              text={t(DIALOG_KEYS.NEXT)}
              onClick={() => setStage(8)}
            />
          </div>
        </div>
      </div>
    )
  }

  function renderTerms() {
    return (
      <div className='d-flex flex-column text-center'>
        <h4 className='my-4'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.TERMS_CONDITIONS)}</h4>
        <div className='row'>
          <Scrollbars
            autoHeight
            autoHide
            autoHeightMin={400}
            thumbMinSize={50}
            autoHeightMax={400}
            autoHideTimeout={2000}
            autoHideDuration={500}>
            <div className='mx-4 text-justify'>{terms}</div>
          </Scrollbars>
          <div className='form-check'>
                    <input
                      name='isDebitCard'
                      onChange={(event) => {
                        setAccepted(event.target.checked)
                      }}
                      type='checkbox'
                      className='form-check-input'
                      id='exampleCheck1'
                    />
                    <label className='control-label' for='exampleCheck1'>
                    {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.TERM_CONDITIONS_TEXT)}
                    </label>
                  </div>
        </div>
        {/* <div className='row mt-3'>
                <div className='col-4'>
              
                </div>
              </div>  */}
        <div className='mt-5 row'>
          <div className='col-4 mx-auto'>
            <NeoButton
              type='button'
              text={t(DIALOG_KEYS.BACK)}
              mode='newDesign'
              onClick={() => {
                setStage(7)
              }}
            />
          </div>
          <div className='col-4 mx-auto'>
            <NeoButton
              type='button'
              disabled={!accepted}
              text={t(DIALOG_KEYS.NEXT)}
              mode='newDesign'
              onClick={async () => {
                setStage(9)
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  function renderConfirm() {
    return (
      <div>
        <h4 className='my-4 text-center'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.TERMS_CONDITIONS)}</h4>
        <div className='row'>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'> {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.IDENTITY_TYPE)}</h6>
            <h6 className='font-weight-bold'>{form1Values?.identityType || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.IDENTITY_NUMBER)}</h6>
            <h6 className='font-weight-bold'> {form1Values?.identityNumber || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.ISSUE_DATE)}</h6>
            <h6 className='font-weight-bold'>{form1Values?.issueDate || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.EXPIRY_DATE)}</h6>
            <h6 className='font-weight-bold'>{form1Values?.expiryDate || '-'}</h6>
          </div>
        </div>
        <div className='row'>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.COUNTRY_OF_ISSUE)}</h6>
            <h6 className='font-weight-bold'>{form1Values?.countryOfIssuance || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.TITLE_FIELD)}</h6>
            <h6 className='font-weight-bold'>{form2Values?.customerInfo || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.FIRST_NAME)}</h6>
            <h6 className='font-weight-bold'>{form2Values?.firstName || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.MIDDLE_NAME)}</h6>
            <h6 className='font-weight-bold'>{form2Values?.middleName || '-'}</h6>
          </div>
        </div>

        <div className='row'>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.LAST_NAME)}</h6>
            <h6 className='font-weight-bold'>{form2Values?.lastName || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.MARITAL_STATUS)}</h6>
            <h6 className='font-weight-bold'>{form2Values?.maritalStatus || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.DATE_OF_BIRTH)}</h6>
            <h6 className='font-weight-bold'>{form2Values?.dateOfBirth || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.PLACE_OF_BIRTH)}</h6>
            <h6 className='font-weight-bold'>{form2Values?.placeOfBirth || '-'}</h6>
          </div>
        </div>

        <div className='row'>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.NATIONALITY)}</h6>
            <h6 className='font-weight-bold'>{form2Values?.nationality || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.PHONE_NUMBER)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.phoneNumber || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.EMAIL_ID)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.emailId || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.HOUSE_NUMBER)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.houseNum || '-'}</h6>
          </div>
        </div>

        <div className='row'>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.STREET_LOCALITY_AREA)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.street || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.REGION)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.city || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.DISTRICT)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.district || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.EMPLOYMENT_TYPE)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.employmentType || '-'}</h6>
          </div>
        </div>

        <div className='row'>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.SOURCE_OF_INCOME)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.sourceOfIncome || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.OCCUPATION)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.occupatio || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.AGE_GROUP)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.ageGroup || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.HOW_KNOW_OUR_BANK)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.howKnowAboutBank || '-'}</h6>
          </div>
        </div>

        <div className='row'>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.INCOME_RANGE)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.incomeRange || '-'}</h6>
          </div>
          <div className='form-group col-3'>
            <h6 className='font-weight-500'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.COUNTRY_CODE)}</h6>
            <h6 className='font-weight-bold'>{form3Values?.countryCode || '-'}</h6>
          </div>
        </div>

        <div className='mt-5 row'>
          <div className='col-4 mx-auto'>
            <NeoButton
              type='button'
              text={t(DIALOG_KEYS.BACK)}
              mode='newDesign'
              onClick={() => {
                setStage(8)
              }}
            />
          </div>
          <div className='col-4 mx-auto'>
            <NeoButton
              type='button'
              disabled={!accepted}
              text={t(DIALOG_KEYS.NEXT)}
              mode='newDesign'
              onClick={async () => {
                await confirmNewCustomerSubmit()
              }}
            />
          </div>
        </div>
      </div>

    )
  }

  function renderSuccess() {
    return (
      <div className='d-flex flex-column text-center'>
        <h4 className='my-4'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.CONGRATULATIONS)}</h4>
        <div className='my-5 py-5'>
          <Congratulations />
        </div>
        <h6 className='col-8 mx-auto px-0'>{message}</h6>
        <div className='mt-5 row'>
          <div className='col-4 mx-auto'>
            <NeoButton type='button'  mode='newDesign' text={t(DIALOG_KEYS.NEXT)} onClick={() => history.push('/auth')} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div id='NewCustomer' className='h-100'>
      <div className='container h-100'>
        <div className='row h-100'>
          <div className='col-10 h-100 mx-auto d-flex align-items-center justify-content-center'>
            <div className='card rounded-4 w-100 newCustomer-content-area'>
              <div className='card-body p-5'>
                <h2>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.TITLE)}</h2>
                <p className='text-secondary small'>
                  {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.WALLET_CUSTOMER_KEYS.SUBTITLE)}
                </p>
                <div id='ProgressBar' className='my-4'>
                  <div className='background' />
                  <div className='progress' style={{ width: `${stage * 10}%` }} />
                </div>
                <div className='my-5' />
                {loading ? renderLoading() : renderSwitch(stage, setStage)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
